/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type SecondaryNavigation_projectGroup = {
    readonly companyProjectGroupId: number | null;
    readonly projectHeaderProjects: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly sprintTimeBox: boolean | null;
            } | null;
        } | null> | null;
    } | null;
    readonly " $refType": "SecondaryNavigation_projectGroup";
};
export type SecondaryNavigation_projectGroup$data = SecondaryNavigation_projectGroup;
export type SecondaryNavigation_projectGroup$key = {
    readonly " $data"?: SecondaryNavigation_projectGroup$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SecondaryNavigation_projectGroup">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "projectHeaderProjects"
        ]
      }
    ]
  },
  "name": "SecondaryNavigation_projectGroup",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "companyProjectGroupId",
      "storageKey": null
    },
    {
      "alias": "projectHeaderProjects",
      "args": null,
      "concreteType": "ProjectTypeConnection",
      "kind": "LinkedField",
      "name": "__ProjectGroup_projectHeaderProjects_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "sprintTimeBox",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProjectGroupType"
};
(node as any).hash = 'f64633b32d8c20593d88da211f676a63';
export default node;
